"use client";

import { Tooltip } from "@nextui-org/react";
import { IoInformationCircleOutline } from "react-icons/io5";

export default function InfoTooltip({ content, className = "", label }) {
  if (!content) return null;

  const ariaLabel = label ? `Más información: ${label}` : "Más información";

  return (
    <Tooltip
      content={
        <span className="block max-w-xs text-left text-sm leading-snug">
          {content}
        </span>
      }
      placement="top"
      showArrow
      delay={300}
      closeDelay={100}
    >
      <button
        type="button"
        className={`inline-flex shrink-0 items-center rounded text-blue-700 hover:text-blue-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:ring-offset-2 ${className}`}
        aria-label={ariaLabel}
      >
        <IoInformationCircleOutline size={18} />
      </button>
    </Tooltip>
  );
}
